import axios from '@/libs/api.request'

//添加地址
export const addAddress = (data) => {
    return axios.request({
        url: '/wxapi-web/customerAddress/addAddress',
        method: 'post',
        data: data
    })
}

//获取地区列表
export const getAddressListByCustomerId = () => {
    return axios.request({
        url: '/wxapi-web/customerAddress/getAddressListByCustomerId',
        method: 'get',
    })
}

//获取单条地址(customer权限)
export const getAddressByIdWithCustomerId = (data) => {
    return axios.request({
        url: '/wxapi-web/customerAddress/getAddressByIdWithCustomerId',
        method: 'get',
        params: data
    })
}

//修改地址
export const editAddress = (data) => {
    return axios.request({
        url: '/wxapi-web/customerAddress/editAddress',
        method: 'PUT',
        data: data
    })
}

//删除地址
export const deleteAddress = (data) => {
    return axios.request({
        url: '/wxapi-web/customerAddress/deleteAddress',
        method: 'DELETE',
        data: data
    })
}

//拼团列表
export const getListForWechat = (data) => {
    return axios.request({
        url: '/wxapi-web/mergerTeam/getListForWechat',
        method: 'get',
        params: data
    })
}


//我的提问 => 未回答
export const getUnAnsweredQustionListForCustomer = (data) => {
    return axios.request({
        url: '/wxapi-web/questionAndAnswer/getUnAnsweredQuestionListForCustomer',
        method: 'get',
        params: data
    })
}

//我的提问 => 已回答
export const getAnsweredQustionListForCustomer = (data) => {
    return axios.request({
        url: '/wxapi-web/questionAndAnswer/getAnsweredQuestionListForCustomer',
        method: 'get',
        params: data
    })
}

//个人中心主页获取头像以及昵称
export const getPersonalCenterUserInfoById = (data) => {
    return axios.request({
        url: '/wxapi-web/user/getPersonalCenterUserInfoById',
        method: 'get',
        params: data
    })
}

//拼团详情信息
export const getCustomerMergerTeamInfoById = (data) => {
    return axios.request({
        url: '/wxapi-web/customerMergerTeamInfo/getCustomerMergerTeamInfoById',
        method: 'get',
        params: data
    })
}

//查询拥有的项目券信息
export const projectCouponInfo = (data) => {
    return axios.request({
        url: `/m/goodsCoupons/details/${data.status}`,
        method: 'get',
    })
}

//获取转赠券详情
export const getTransferCouponDetail = (data) => {
    return axios.request({
        url: '/wxapi-web/goodsCoupon/getTransferCouponDetail',
        method: 'get',
        params: data
    })
}


//领取赠送券
export const receiveTransferCoupon = (data) => {
    return axios.request({
        url: '/wxapi-web/goodsCoupon/receiveTransferCoupon',
        method: 'PUT',
        data: data
    })
}


//获取转赠券详情
export const sendTransferCouponDetail = (data) => {
    return axios.request({
        url: '/wxapi-web/goodsCoupon/sendTransferCouponDetail',
        method: 'get',
        params: data
    })
}

//取消转赠
export const cancelTransferCoupon = (data) => {
    return axios.request({
        url: '/wxapi-web/goodsCoupon/cancelTransferCoupon',
        method: 'PUT',
        data: data
    })
}


//修改领券码
export const editTransferCouponValidCode = (data) => {
    return axios.request({
        url: '/wxapi-web/goodsCoupon/editTransferCouponValidCode',
        method: 'PUT',
        data: data
    })
}

//查看客户积分详情
export const getCustomerIntegrationDetailByRequest = (data) => {
    return axios.request({
        url: '/wxapi-web/integration/getCustomerIntegrationDetailByRequest',
        method: 'get',
        params: data
    })
}


//获取线下积分
export const getOfflineCustomerIntegrationByCustomerId = (data) => {
    return axios.request({
        url: '/wxapi-web/integration/getOfflineCustomerIntegrationByCustomerId',
        method: 'get',
        params: data
    })
}


//迁移线下积分到线上
export const migrateIntegration = (data) => {
    return axios.request({
        url: '/wxapi-web/integration/migrateIntegration',
        method: 'post',
        data: data
    })
}


//获取个人二维码
export const getCustomerIdentityQrCode = (data) => {
    return axios.request({
        url: '/wxapi-web/customer/getCustomerIdentityQrCode',
        method: 'get',
        responseType: 'arraybuffer',
        params: data
    })
}


//代金券

//用户领取代金券 - 移动端
export const userTakeVoucherCoupon = (data) => {
    return axios.request({
        url: '/wxapi-web/voucherCoupon/userTakeVoucherCoupon',
        method: 'get',
        params: data
    })
}

//验证用户是否可以领取 - 移动端
export const verifyUserCanTakeVoucherCoupon = (data) => {
    return axios.request({
        url: '/wxapi-web/voucherCoupon/verifyUserCanTakeVoucherCoupon',
        method: 'get',
        params: data
    })
}


//根据活动编号获取代金券信息 - 移动端
export const getVoucherCouponInfoByActivityId = (data) => {
    return axios.request({
        url: '/wxapi-web/voucherCoupon/getVoucherCouponInfoByActivityId',
        method: 'get',
        params: data
    })
}


//查询拥有的代金券信息(customer/user权限)
export const GetCouponDetailListByUserIdDJQ = (data) => {
    return axios.request({
        url: `/m/voucherCoupons/details/${data.status}`,
        method: 'get'
    })
}

//抽奖券

//根据活动编号获取抽奖券信息
export const getLotteryCouponInfoByActivityId = (data) => {
    return axios.request({
        url: '/wxapi-web/lotteryCoupon/getLotteryCouponInfoByActivityId',
        method: 'get',
        params: data
    })
}

//验证用户是否可以领取
export const verifyUserCanTakeLotteryCoupon = (data) => {
    return axios.request({
        url: '/wxapi-web/lotteryCoupon/verifyUserCanTakeLotteryCoupon',
        method: 'get',
        params: data
    })
}

//用户领取抽奖券
export const userTakeLotteryCoupon = (data) => {
    return axios.request({
        url: '/wxapi-web/lotteryCoupon/userTakeLotteryCoupon',
        method: 'get',
        params: data
    })
}

//查询拥有的抽奖券信息
export const lotteryCouponGetCouponDetailListByUserId = (data) => {
    return axios.request({
        url: `/m/lotteryCoupons/details/${data.status}`,
        method: 'get'
    })
}


//领取活动奖励  
export const receivingActivityAwards = (data) => {
    return axios.request({
        url: `/m/activities/getRewards/${data.activityId}?employeeId=${data.eid}&channelId=${data.cid}`,
        method: 'post'
    })
}

//是否可以参加指定活动  
export const activitiesCanTake = (data) => {
    return axios.request({
        url: `/m/activities/canTake/${data}`,
        method: 'get'
    })
}

//获取活动页主背景图  
export const activityPageBackgroundImageUrl = (data) => {
    return axios.request({
        url: `/m/activities/activityPage/backgroundImageUrl/${data}`,
        method: 'get'
    })
}

//获取活动页主背景图&onlyCustomer
export const giftActivityPageInfo = (data) => {
    return axios.request({
        url: `/m/activities/activityPage/info/${data}`,
        method: 'get'
    })
}

//生成代金劵二维码  
export const writeOffVoucherQrCode = (data) => {
    return axios.request({
        url: `/ol/mobile/qrcode/voucherCouponQrCode/${data.id}`,
        method: 'get',
        params: data.info
    })
}

//生成抽奖劵二维码  
export const writeOffLotteryCouponQrCode = (data) => {
    return axios.request({
        url: `/ol/mobile/qrcode/lotteryCouponQrCode/${data.id}`,
        method: 'get',
        params: data.info
    })
}

//生成项目劵二维码  
export const writeOffGoodsCouponQrCode = (data) => {
    return axios.request({
        url: `/ol/mobile/qrcode/goodsCouponQrCode/${data.id}`,
        method: 'get',
        params: data.info
    })
}

//生成订单信息二维码  
export const writeOffOrderInfoQrCode = (data) => {
    return axios.request({
        url: `/ol/mobile/qrcode/orderInfoQrCode/${data.id}`,
        method: 'get',
        params: data.info
    })
}

//生成订单明细二维码  
export const writeOffOrderDetailQrCode = (data) => {
    return axios.request({
        url: `/ol/mobile/qrcode/orderDetailQrCode/${data.id}`,
        method: 'get',
        params: data.info
    })
}



//案例征集API

//取案例征集活动信息
export const getCaseCollectionActivitiesInfo = (activityId) => {
    return axios.request({
        url: `/m/caseCollectionActivities/activityPage/info/${activityId}`,
        method: 'get'
    })
}

//是否可以参与活动报名
export const caseCollectionActivitiesCanTake = (activityId) => {
    return axios.request({
        url: `/m/caseCollectionActivities/activityPage/canTake/${activityId}`,
        method: 'get'
    })
}

//案例报名提交
export const caseCollectionActivitiesSubmit = (data) => {
    return axios.request({
        url: '/m/caseCollectionActivities/activityPage/takePart',
        method: 'post',
        data: data
    })
}


//根据订单编号取订单信息
export const ordersDetails = (orderId) => {
    return axios.request({
        url: `/m/orders/${orderId}`,
        method: 'get'
    })
}


//根据客户编号取客户的订单列表
export const listByCustomerIdOrderList = (data) => {
    return axios.request({
        url: `/m/orders/listByCustomerId?isPayed=${data.isPayed}&pageNum=${data.pageNum}&pageSize=${data.pageSize}&hadWriteOff=${data.hadWriteOff}`,
        method: 'get'
    })
}


//appid
export const wxGetAppId = () => {
    return axios.request({
        url: `/wxapim/wxapi/wxGetAppId`,
        method: 'get'
    })
}


//wxGetJsApiSignatureBySignUrl
export const wxGetJsApiSignatureBySignUrl = (url) => {
    return axios.request({
        url: `/wxapim/wxapi/wxGetJsApiSignatureBySignUrl`,
        method: 'get',
        params: {
            url: url
        }
    })
}


//微信支付
export const wxpay = (data) => {
    return axios.request({
        url: '/wxapim/wxPay',
        method: 'get',
        params: data
    })
}


//检查订单是否支付
export const checkOrderIsPayed = (orderId) => {
    return axios.request({
        url: `/m/orders/checkOrderIsPayed/${orderId}`,
        method: 'get'
    })
}


// WEBPACK FOOTER //
// ./src/api/personal.js